import { render, staticRenderFns } from "./ChamberEdit.vue?vue&type=template&id=42ae9fa7&scoped=true&"
import script from "./ChamberEdit.vue?vue&type=script&lang=js&"
export * from "./ChamberEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ae9fa7",
  null
  
)

export default component.exports